import React, { memo } from 'react';
import { PasswordInput } from '@adc/parallax-component-library';
import { InputErrorField } from 'Components/utility';
const InputPassword = memo(({ isInvalid = false, label = '', errorMessage, placeholder = '', onBlur, onFocus, setFieldValue, mt, mb, autoComplete = 'current-password', isDisabled, onChangeText, testID, value, ...rest }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(PasswordInput, { label: label, valid: isInvalid ? 'no' : 'yes', onBlur: onBlur, onFocus: onFocus, ariaLabelExtractor: () => '', hideButtonAriaLabelExtractor: () => '', autoComplete: autoComplete, marginTop: mt, marginBottom: mb, disabled: isDisabled, placeholder: placeholder, onChangeText: onChangeText, testID: testID, 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            value: value, ...rest }),
        isInvalid && errorMessage && (React.createElement(InputErrorField, { errorMessage: errorMessage, testID: testID }))));
});
InputPassword.displayName = 'InputPassword';
export { InputPassword };
